import { makeStyles } from '@material-ui/core';
import rootenyIcon from '../../assets/rooteny-icon.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 32,
    display: 'block',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.img}
      src={rootenyIcon}
      alt="Rooteny"
    />
  );
};
